import { PaginatedResponse, PaginationType, SearchParams } from "helpers";
import { api } from "services";
import { imageToFormData, postImage } from "services/images";

import { recipeToBody, resToRecipe } from "./transformations";
import { Recipe } from "./types";

export const getRecipes = async (
  pagination: PaginationType,
  search: SearchParams
): Promise<PaginatedResponse<Recipe>> => {
  const params = [
    `pageNumber=${pagination.currentPage}`,
    `pageSize=${pagination.pageSize}`,
    `sortBy=${search.sortBy}`,
    `desending=${search.descending}`,
    `search=${search.search}`,
  ];
  const url = `/recipes?${params.join("&")}`;
  const resp = await api.get(url);
  return { data: resp.data.data.map(resToRecipe), meta: resp.data.meta };
};

export const getRecipe = async (id: number): Promise<Recipe> => {
  const resp = await api.get(`/recipes/${id}`);
  return resToRecipe(resp.data);
};

export const putRecipe = async (data: Recipe): Promise<Recipe> => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = recipeToBody(data);
  const resp = await api.put(`/recipes/${data.id}`, body);
  return resToRecipe(resp.data);
};

export const postRecipe = async (data: Recipe) => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = recipeToBody(data);
  const resp = await api.post(`/recipes`, body);
  return resToRecipe(resp.data);
};

export const publishRecipe = async (id: number, published: boolean) => {
  const resp = await api.put(`recipes/${id}/publish`, { published });
  return resToRecipe(resp.data);
};

export const deleteRecipe = async (id: number): Promise<void> => {
  await api.delete(`/recipes/${id}`);
};
